"use client";

/**
 * Modal inferior para elegir presentación al agregar un boot:
 * unidad, pack 7 o pack 14 (con su precio), más el acceso al pack variado.
 */

import Link from "next/link";

import { useApp } from "./proveedor";
import { PrecioDist } from "./precio-dist";
import { clave, precioPresentacion, type Pres } from "./presentaciones";
import type { ProductoApp } from "./tipos";

export function SelectorPresentacion({
  producto,
  abierto,
  onCerrar,
}: {
  producto: ProductoApp;
  abierto: boolean;
  onCerrar: () => void;
}) {
  const { agregar, descuentoDist } = useApp();

  if (!abierto) return null;

  const opciones: { pres: Pres; titulo: string; detalle: string; precio: number | null }[] = [
    {
      pres: "unidad",
      titulo: "Unidad",
      detalle: "210 g · 1 jugo",
      precio: producto.precio,
    },
    {
      pres: "pack7",
      titulo: "Pack 7",
      detalle: "Una semana de jugos",
      precio: precioPresentacion(producto, "pack7"),
    },
    {
      pres: "pack14",
      titulo: "Pack 14",
      detalle: "Dos semanas de jugos",
      precio: precioPresentacion(producto, "pack14"),
    },
  ];

  function elegir(pres: Pres) {
    agregar(clave(producto.slug, pres));
    onCerrar();
  }

  return (
    <div className="fixed inset-0 z-40 flex items-end justify-center">
      <button
        type="button"
        aria-label="Cerrar"
        onClick={onCerrar}
        className="absolute inset-0 bg-black/50"
      />
      <div className="anim-bz-up relative z-10 w-full max-w-[430px] rounded-t-[34px] bg-white p-6 pb-8">
        <div className="mx-auto h-1 w-10 rounded-full bg-black/15" />
        <div className="mt-4 flex items-center gap-3">
          <span
            className="h-11 w-11 flex-none rounded-[14px]"
            style={{ background: producto.gradiente }}
          />
          <div>
            <div className="font-app text-lg font-black">{producto.nombre}</div>
            <div className="text-xs text-tinta/55">Elige tu presentación</div>
          </div>
        </div>

        <div className="mt-4 flex flex-col gap-2">
          {opciones.map((o) => (
            <button
              key={o.pres}
              type="button"
              onClick={() => elegir(o.pres)}
              disabled={o.precio === null}
              className="flex h-[60px] items-center justify-between rounded-[20px] border border-black/10 bg-white px-5 text-left transition active:scale-[.98] disabled:opacity-40"
            >
              <span>
                <span className="block font-app text-base font-semibold">
                  {o.titulo}
                </span>
                <span className="block text-xs text-tinta/55">{o.detalle}</span>
              </span>
              <span className="font-app text-base font-black">
                <PrecioDist
                  precio={o.precio}
                  descuento={descuentoDist}
                  claseTachado="text-[13px]"
                />
              </span>
            </button>
          ))}
        </div>

        <Link
          href="/packs"
          onClick={onCerrar}
          className="mt-3 block rounded-[20px] bg-lima/20 p-4 text-center text-[13px] font-medium text-bosque"
        >
          ¿Quieres combinar sabores? <span className="underline">Arma un pack variado</span>
        </Link>
      </div>
    </div>
  );
}
